module.exports = __webpack_public_path__ + "img/kitkitphoto6.820a93bf.jpg";